import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const AudioVolumeOn = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M19.707 10.293C19.526 10.112 19.276 10 19 10C18.448 10 18 10.448 18 11C18 11.276 18.112 11.526 18.293 11.707C19.282 12.696 20 14.502 20 16C20 17.498 19.282 19.304 18.293 20.293C18.112 20.474 18 20.724 18 21C18 21.552 18.448 22 19 22C19.276 22 19.526 21.888 19.707 21.707C21.057 20.357 22 18.01 22 16C22 13.99 21.057 11.643 19.707 10.293Z" />
		<path d="M23.707 6.293C23.526 6.112 23.276 6 23 6C22.448 6 22 6.448 22 7C22 7.276 22.112 7.526 22.293 7.707C24.684 10.097 26 13.043 26 16C26 18.957 24.683 21.902 22.293 24.293C22.112 24.474 22 24.724 22 25C22 25.552 22.448 26 23 26C23.276 26 23.526 25.888 23.707 25.707C26.475 22.939 28 19.491 28 16C28 12.509 26.476 9.061 23.707 6.293V6.293Z" />
		<path d="M15 4C14.724 4 14.474 4.112 14.293 4.293L8.586 10H7C5.346 10 4 11.346 4 13V19C4 20.654 5.346 22 7 22H8.586L14.293 27.707C14.474 27.888 14.724 28 15 28C15.552 28 16 27.552 16 27V5C16 4.448 15.552 4 15 4ZM9 20H7C6.449 20 6 19.551 6 19V13C6 12.449 6.449 12 7 12H9C9.265 12 9.52 11.895 9.707 11.707L14 7.414V24.586L9.707 20.293C9.519 20.106 9.265 20 9 20V20Z" />
	</svg>
);

export default AudioVolumeOn;
